import { compose, withHandlers } from 'recompose';

import { isBrandPromoError } from '../utils';
import withToggle from '../../../../common/hoc/withToggle';

export default compose(
  withToggle('brandError'),
  withHandlers({
    onSubmit: props => (...data) => {
      return props.onSubmit(...data)
        .catch((error) => {
          if (isBrandPromoError(error)) {
            props.brandErrorOn();
          }
          throw error;
        });
    },
  }),
);
